import {
  setSubdomain as setSd,
  setBookingMode as setBM,
} from './checkout.slice';
import {
  useChangeStatusMutation,
  useReleaseBookingMutation,
} from './checkout.api';
import { useDispatch, useSelector } from 'react-redux';

export default function useCheckout() {
  const dispatch = useDispatch();
  const [changeStatus] = useChangeStatusMutation();
  const [releaseBooking] = useReleaseBookingMutation();

  const subdomain = useSelector((state) => state.checkout.subdomain);

  const checkout = useSelector((state) => state.checkout);

  const setSubdomain = (subdomain) => {
    dispatch(setSd(subdomain));
  };

  const setBookingMode = (mode) => {
    dispatch(setBM(mode));
  };

  const changeBookingStatus = async (screen, booking_id, event_id) => {
    const body = {
      event_id,
      booking_number: booking_id,
      screen,
    };
    try {
      return await changeStatus(body);
    } catch {
      return false;
    }
  };

  return {
    subdomain,
    checkout,
    setSubdomain,
    setBookingMode,
    changeBookingStatus,
    releaseBooking,
  };
}
